import React from "react";
import {
  AvatarButton,
  AvatarIcon,
  AvatarImage,
  AvatarSvg,
  AvatarText,
} from "@sonder/ui/source/styled/fragments/Avatar";

const parseInitials = (name: string = "") => {
  const nameParts = name.replace(".", "").split(" ");
  const firstName = nameParts[0];
  const lastName = nameParts.length > 1 ? nameParts[nameParts.length - 1] : "";
  return firstName || lastName
    ? `${firstName?.[0] || ""}${lastName?.[0] || ""}`.toUpperCase()
    : "?";
};

export interface AvatarProps {
  className?: string;
  name?: string | null;
  imageUrl?: string | null;
  onClick?(e: React.MouseEvent): void;
  svg?: JSX.Element | null;
}
export const Avatar = ({
  className,
  name,
  imageUrl,
  onClick,
  svg,
}: AvatarProps) => {
  let content = null;
  if (!name) content = <AvatarIcon className={className} />;
  else if (imageUrl)
    content = (
      <AvatarImage
        className={className}
        draggable={false}
        src={imageUrl}
        title={name}
      />
    );
  else if (svg)
    content = (
      <AvatarSvg className={className} title={name}>
        {svg}
      </AvatarSvg>
    );
  else
    content = (
      <AvatarText className={className} title={name}>
        {parseInitials(name)}
      </AvatarText>
    );

  return typeof onClick === "function" ? (
    <AvatarButton className={className} title={name || ""} onClick={onClick}>
      {content}
    </AvatarButton>
  ) : (
    content
  );
};
